import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Copyright from './Copyright';
import Logo from './Logo';
import { useAuth0 } from "@auth0/auth0-react";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));


function Login() {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let error = params.get('error');
  let errorDescription = params.get('error_description');

  const classes = useStyles();
  const { loginWithPopup, isAuthenticated } = useAuth0();

  const handleLogin = async () => {
    await loginWithPopup({
      scope: 'openid profile email read:user read:grants offline_access ',
    });
  }

  if(isAuthenticated) {
    window.location.href = window.location.origin;
  }

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Logo />

        {error && errorDescription && (
          <>  
            <h2 style={{color: 'red'}}>{error?.toUpperCase()}</h2>
            <h4>{errorDescription}</h4>
          </>
        )}
        
        <Button 
          type="submit" 
          fullWidth 
          variant="contained" 
          color="primary"
          className={classes.submit}
          onClick={() => handleLogin()}
        >
          Sign In
        </Button>

      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default Login;
